import { createContext, useContext } from "react";

import { useNewRelicInitialize } from "@/lib/new-relic/initialize";

import type { BrowserAgent } from "@newrelic/browser-agent/src/loaders/browser-agent.js";

type Props = {
	children: React.ReactNode;
};

type NewRelicContextType = {
	newRelic: BrowserAgent;
};

export const NewRelicContext = createContext<NewRelicContextType>({} as unknown as NewRelicContextType);

export const useNewRelic = () => {
	const { newRelic } = useContext(NewRelicContext);

	if (!newRelic) {
		throw new Error("useNewRelic must be used within a NewRelicProvider");
	}

	return { newRelic };
};

export const NewRelicProvider = ({ children }: Props) => {
	const { newRelic } = useNewRelicInitialize();

	return <NewRelicContext.Provider value={{ newRelic }}>{children}</NewRelicContext.Provider>;
};
